import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Table,
  Button,
} from "reactstrap";
import moment from "moment";
import { getReports } from "../../slices/general/thunk";
import { useDispatch } from "react-redux";
import { useCurrentUser } from "../../slices/auth/hooks";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../Components/Loading";
import { useNavigate } from "react-router-dom";
import HeadersRole from "../../Components/Headers/HeadersRole";
import reportsIcon from "../../assets/images/iconsRoles/IndividualsIcon.svg";
import FooterPagination from "../../Components/Pagination/FooterPagination";

const DashboardReports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const currentUser = useCurrentUser();
  const [reports, setReports] = useState([]);

  const [pageSize, setPageSize] = useState(10);
  const [hasMore, setHasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const fetchReports = async () => {
    try {
      setLoading(true);
      const res = await dispatch(
        getReports({
          userId: currentUser.id,
          page: currentPage,
          pageSize: 10,
        })
      );

      setReports(res.payload?.data || []);
      setHasMore(res.payload?.hasMore || false);
      setPageSize(res.payload?.pageSize || 10);
      // Calculate total items based on hasMore
      const currentItems = res.payload?.data?.length || 0;
      if (res.payload?.hasMore) {
        setTotalItems((currentPage + 2) * pageSize); // At least one more page
      } else {
        setTotalItems(currentPage * pageSize + currentItems);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, [currentPage]);

  const handleRowClick = (reportId) => {
    navigate(`/reports/${reportId}`);
  };

  return (
    <div className="page-content px-0">
      <Container fluid>
        <HeadersRole
          role="Reports"
          icon={reportsIcon}
          svg={true}
          text={
            <span className="fs-15 text-muted fw-normal">
              View detailed breakdown of your invoices
            </span>
          }
        />
        <div className="mb-4 pb-3 card">
          <div className="card-body">
            <Col xl={12}>
              <div className="table-container position-relative">
                {loading && <Loading />}
                <div className="live-preview">
                  <div className="table-responsive">
                    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
                      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
                        <tr>
                          <th scope="col">Month</th>
                          <th scope="col">Created On</th>
                          <th scope="col" className="text-center" style={{ width: "150px" }}>
                            Manage
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reports.length === 0 && !loading ? (
                          <tr>
                            <td colSpan="3" className="text-center">
                              No reports found
                            </td>
                          </tr>
                        ) : (
                          reports.map((report, index) => {
                            return (
                              <tr
                                key={report.id || index}
                                onClick={() => handleRowClick(report?.id)}
                                className="cursor-pointer"
                              >
                                {/*
                                  effectiveForDate on the report mirrors the
                                  invoice's "next coverage ED" (the 1st of the
                                  month AFTER the period the report actually
                                  covers). E.g. an invoice generated on Mar-20
                                  has effectiveForDate=May-1 and the report
                                  covers the month of work / payments that
                                  happened in March. Subtracting TWO months
                                  yields the correct human label ("March 2026"
                                  instead of "April 2026"). See:
                                  baxrx-server CronJob_lockEmployerEmployees… +
                                  generateMonthlyReportFromInvoice.
                                */}
                                <td>{moment.utc(report?.effectiveForDate).subtract(2, 'month').format("MMMM YYYY")}</td>
                                <td>{moment.utc(report?.effectiveForDate).format("MM/DD/YYYY")}</td>
                                <td className="py-0 text-center">
                                  <Button
                                    color="soft-primary"
                                    size="sm"
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleRowClick(report?.id);
                                    }}
                                  >
                                    View
                                  </Button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                      {totalItems > 0 && (
                        <tfoot>
                          <FooterPagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalItems / pageSize)}
                            totalItems={totalItems}
                            pageSize={pageSize}
                            onChangePage={handleChangePage}
                          />
                        </tfoot>
                      )}
                    </Table>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DashboardReports;
